import { GHALISHOR_API_V1_PREFIX, type VerifyOtpResponse } from './identity-access';

export const PASSWORD_AUTH_ROUTES = Object.freeze({
  register: `${GHALISHOR_API_V1_PREFIX}/auth/password/register`,
  login: `${GHALISHOR_API_V1_PREFIX}/auth/password/login`,
  change: `${GHALISHOR_API_V1_PREFIX}/auth/password/change`,
  status: `${GHALISHOR_API_V1_PREFIX}/auth/password/status`,
  forgot: `${GHALISHOR_API_V1_PREFIX}/auth/password/forgot`,
  reset: `${GHALISHOR_API_V1_PREFIX}/auth/password/reset`,
} as const);

export interface PasswordRegisterRequest {
  readonly mobile: string;
  readonly email: string;
  readonly displayName: string;
  readonly password: string;
}

export interface PasswordLoginRequest {
  readonly mobile: string;
  readonly password: string;
}

export interface PasswordChangeRequest {
  readonly currentPassword?: string;
  readonly newPassword: string;
}

export interface PasswordLoginResponse extends VerifyOtpResponse {
  readonly mustChangePassword: boolean;
}

export interface PasswordRegisterResponse extends PasswordLoginResponse {}

export interface PasswordForgotRequest {
  readonly email: string;
}

export interface PasswordForgotResponse {
  readonly accepted: true;
  readonly message: string;
}

export interface PasswordResetRequest {
  readonly token: string;
  readonly newPassword: string;
}

export interface PasswordResetResponse {
  readonly success: true;
}

export interface PasswordStatusResponse {
  readonly hasPassword: boolean;
  readonly mustChangePassword: boolean;
}

export interface PasswordChangeResponse {
  readonly success: true;
}
